import React from 'react';
import { useAppContext } from '../../Context';
import { useTranslation } from '../../TranslationContext';

function ConfirmDialog({ message, onConfirm }) {
	
	const { isConfirmDialogOpen, setIsConfirmDialogOpen } = useAppContext();
	const { t } = useTranslation();

	const closeDialog = () => setIsConfirmDialogOpen(false);

	const handleConfirm = () => {
		onConfirm();
		closeDialog();
	};

	return (
		<>
			{isConfirmDialogOpen && (
				<div className="confirmModal">
					<div className="confirmModalContent">
						<p style={{textAlign: "center"}}>{message}</p>
						<button onClick={handleConfirm}>{t('confirmBoxConfirm')}</button>
						<button onClick={closeDialog} style={{float: "right"}}>{t('confirmBoxCancel')}</button>
					</div>
				</div>
			)}
		</>
	);
}

export default ConfirmDialog;